export const initBlockData = {
  title: "Registration",
};

export const initEmptyBlockData = {
  title: ""
};
